import React from 'react';

interface ComingSoonProps {
  featureName?: string;
}

export const ComingSoon: React.FC<ComingSoonProps> = ({ featureName }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
      <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-6">
        <svg className="w-8 h-8 text-white/40" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
      </div>
      <h2 className="text-2xl font-semibold text-white mb-2">Coming Soon</h2>
      {featureName && (
        <p className="text-white/60 text-lg">{featureName} is currently under development.</p>
      )}
      <p className="text-white/40 mt-2 text-sm">Check back later for updates.</p>
    </div>
  );
};
